export default __webpack_public_path__ + "static/media/facebook.fea6c2fd.svg";